import { render, staticRenderFns } from "./WaterAction.vue?vue&type=template&id=4d647375&scoped=true&"
import script from "./WaterAction.vue?vue&type=script&lang=js&"
export * from "./WaterAction.vue?vue&type=script&lang=js&"
import style0 from "./WaterAction.vue?vue&type=style&index=0&id=4d647375&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d647375",
  null
  
)

export default component.exports